import { Card } from "antd";
import Meta from "antd/lib/card/Meta";
import React from "react";

const Services = (props) => {
    return (
      <Card
        data-aos='zoom-in'
        data-aos-delay={props.delay}
        hoverable
        className='card-services'
      >
        <img src={props.image} width={100} height={100} alt='Gambar-Bahan' />
        <Meta
          title={<h3>{props.title}</h3>}
          description={<p>{props.desc}</p>}
        />
      </Card>
    );
}

export default Services;